import React from 'react';

export const ActiveTxNote = ({ list, isRTL, compact }) => {
  if (!list || !list.length) return null;
  return (
    <div className={`rounded-xl bg-amber-50 border border-amber-300 ${compact ? 'p-2' : 'p-2.5'} text-[11px] text-amber-900`} dir={isRTL ? 'rtl' : 'ltr'} data-testid="active-tx-note">
      <p className="font-bold flex items-center gap-1">⚠️ {isRTL ? `لدى هذا المتعامل ${list.length > 1 ? list.length + ' معاملات جارية' : 'معاملة جارية'}` : `This customer has ${list.length} active transaction(s)`}</p>
      {list.map(t => <p key={t.id} className="mt-0.5 truncate">• {t.service} — <span className="font-bold" dir="ltr">{t.done}/{t.total}</span> {isRTL ? 'مكتمل' : 'done'}{t.current ? ` · ${isRTL ? 'الحالي' : 'now'}: ${t.current}` : ''} <a href={`/external?q=${encodeURIComponent(t.request_id.slice(0, 8))}`} className="underline ms-1" onClick={e => e.stopPropagation()}>{isRTL ? 'فتح' : 'open'}</a></p>)}
    </div>
  );
};
